import { render, staticRenderFns } from "./add_complete.vue?vue&type=template&id=970d4398"
import script from "./add_complete.vue?vue&type=script&lang=js"
export * from "./add_complete.vue?vue&type=script&lang=js"
import style0 from "./add_complete.vue?vue&type=style&index=0&id=970d4398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports